import api from "./api";

// Process Status service (CRUD)
// GET    /process-status
// GET    /process-status/:id
// POST   /process-status
// PATCH  /process-status/:id
// DELETE /process-status/:id

export async function getProcessStatuses() {
  const res = await api.get("/process-status");
  return Array.isArray(res) ? res : [];
}

export async function getProcessStatusById(statusId) {
  if (statusId === undefined || statusId === null || statusId === "") {
    throw new Error("statusId is required");
  }
  const idNum = Number(statusId);
  if (!Number.isInteger(idNum)) throw new Error("statusId must be an integer");
  return api.get(`/process-status/${idNum}`);
}

export async function createProcessStatus(payload) {
  return api.post("/process-status", payload || {});
}

export async function updateProcessStatus(statusId, payload) {
  const idNum = Number(statusId);
  if (!Number.isInteger(idNum)) throw new Error("statusId must be an integer");
  const body = { ...(payload || {}) };
  delete body.id;
  return api.patch(`/process-status/${idNum}`, body);
}

export async function deleteProcessStatus(statusId) {
  const idNum = Number(statusId);
  if (!Number.isInteger(idNum)) throw new Error("statusId must be an integer");
  return api.delete(`/process-status/${idNum}`);
}
